import {
    map,
    pluck,
    tap,
    startWith,
    mapTo,
    filter,
    catchError,
    exhaustMap,
    distinctUntilChanged
} from 'rxjs/operators';
import { getHttpAxiosAsObservable, VALUE_WATCH } from '../utils';
import { Observable } from 'rxjs';
import { Filter } from '../models';

export const log = (label?: string) =>
    tap(value => {
        if (label) {
            // console.log(`[${label}]`, value);
        } else {
            // console.log(value);
        }
    });

export const pluckAndStartWatch = (start: any) => {
    return (src: Observable<any>) =>
        src.pipe(
            pluck(VALUE_WATCH),
            startWith(start)
        );
};

export const mapAndStartWatch = (start: any, mapFunction: (value: any) => any) => {
    return (src: Observable<any>) =>
        src.pipe(
            pluckAndStartWatch(start),
            map(mapFunction)
        );
};

export const mapPosition = (position: number) => (src: Observable<any>) =>
    src.pipe(map(element => (element && Array.isArray(element) && element.length ? element[position] : element)));

export const setMessage = (title: string, tapFunction?: () => void) => (src: Observable<any>) =>
    src.pipe(
        filter(state => state),
        mapTo(title),
        tap(() => (tapFunction ? tapFunction() : () => {}))
    );

export const existCountElement = (arg: number | filterPredicate) => (filterSelected: Observable<Filter[]>) =>
    filterSelected.pipe(map(selecteds => (typeof arg === 'function' ? arg(selecteds) : selecteds.length === arg)));

export type filterPredicate = (filterSelected: Filter[]) => boolean;

export const fromService = (promise: Promise<any>, token: any, errorFun: (error: any) => Observable<any>) => {
    return (src: Observable<any>) =>
        src.pipe(exhaustMap(() => getHttpAxiosAsObservable(promise, token).pipe(catchError(error => errorFun(error)))));
};

export const select = <T, R>(source: (value: T) => R) => (src: Observable<any>) =>
    src.pipe(
        map<T, R>(source),
        distinctUntilChanged()
    );

export const queryState = (source: string) => (src: Observable<any>) =>
    src.pipe(
        pluck(source),
        distinctUntilChanged()
    );
